export default "__VITE_ASSET__CxRAcysa__"